var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCase = function SvgCase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.511v-.833c0-.442-.184-.866-.513-1.178a1.795 1.795 0 0 0-1.237-.489h-3.5c-.464 0-.91.176-1.237.489A1.627 1.627 0 0 0 6.5 2.678v.833",
    stroke: "#2A2A2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 4.051,
    width: 19,
    height: 13,
    rx: 1.5,
    stroke: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A2A2A",
    d: "M7.141 10.828h5.723M.246 6.855l7.139 4.037M12.613 10.892l7.139-4.037"
  })));
};
export default SvgCase;